import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import { Box, Button, Card, CardContent, Tabs, Tab, IconButton, Dialog, DialogTitle, Grid, Typography, DialogContent, Tooltip, FormControlLabel, Switch, Paper } from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import MUIDataTable, {
  MUIDataTableColumnOptions,
  MUIDataTableMeta,
  SelectableRows
} from 'mui-datatables';
import { MUITranslations } from '../../../helpers/MUITableTranslations';
import { RouteComponentProps } from 'react-router';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { IReferentialService } from '../../../services/Interfaces/IReferentialService';
import { isNullOrUndefined } from 'util';
import _ from 'lodash';
import { GTOperationEnum, RefConstants } from '../../../helpers/Constants';
import { IReferential } from '../../../interfaces/IReferential';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import NumberFormat from 'react-number-format';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import CloseIcon from '@material-ui/icons/Close';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import MaterialTable from 'material-table';
import { getLocalization, MaterialTableIcons } from '../../_shared/TableSettings';
import { CloudUploadOutlined } from '@material-ui/icons';
import { GTPartMapping, GTPartMappingImportedDto, GTPartMappingImportRequestDto, ImportGTPartMappingAttachment } from '../../../interfaces/Case';
import { ICaseService } from '../../../services/Interfaces/ICaseService';

interface IGTPartMappinsState {
  gtPartMappings: GTPartMapping[];
  isLoading: boolean;
  parts: IReferential[];
  operationList: IReferential[];
  organizationId: number;
  newGTPartMapping: GTPartMapping;
  newGTPartMappingId: number | null;
  isDialogOpen: boolean;
  isLoadingImportData: boolean;
  isImportDialogOpen: boolean;
  attachments: ImportGTPartMappingAttachment[];
  importedGTPartMappingList: GTPartMappingImportedDto[];
}

type IOrganizationPartsProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string;}>;

class GTPartMappings extends React.PureComponent<IOrganizationPartsProps, IGTPartMappinsState> {
  private translatorService!: ITranslatorService;
  private appReferentialService!: IReferentialService;
  private caseService!: ICaseService;

  static contextType = ApplicationContext;
  private newGTPartMapping = {
    id: 0,
    organizationId: 0,
    gtPartId: 0,
    gtPart: null,
    operationId: 0,
    operation: null
  } as GTPartMapping;

  state = {
    gtPartMappings: [],
    isLoading: false,
    parts: [],
    operationList: [],
    organizationId: 0,
    newGTPartMapping: this.newGTPartMapping,
    newGTPartMappingId: null,
    isDialogOpen: false,
    isLoadingImportData: false,
    isImportDialogOpen: false,
    attachments: [],
    importedGTPartMappingList: []
  } as IGTPartMappinsState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadData();
      }
    );
  }

  loadData = async () => {
    const hoId = Number.parseInt(this.props.match.params.id);

    if (Number.isNaN(hoId)) {
      return;
    }
    const { gtPartRef, operationRef } = RefConstants;

    let parts: IReferential[];
    let operationList: IReferential[];
    let gtPartMappings: GTPartMapping[];
    try {
      [parts, operationList, gtPartMappings] = await Promise.all([
        this.appReferentialService.Get(gtPartRef!.baseUrl),
        this.appReferentialService.Get(operationRef!.baseUrl),
        this.caseService.GetGTPartMappings(hoId),
      ]);
    } catch (error) {
      const message =
        (error as any)?.response?.status === 403
          ? this.translatorService.Tranlate(
              'GT_PART_MAPPINGS_FORBIDDEN_MSG',
              'Nu aveti acces la piesele GT ale acestei organizatii!'
            )
          : this.translatorService.Tranlate('ERROR_MSG', 'Eroare');
      this.props.enqueueSnackbar(message, { variant: 'error' });
      this.setState({ gtPartMappings: [], isLoading: false });
      return;
    }

    gtPartMappings.forEach((ojt) => {
      const part = parts.find((item) => item.id === ojt.gtPartId);
      const operation = operationList.find((item) => item.id === ojt.operationId);

      ojt.gtPart = isNullOrUndefined(part) ? null : part;
      ojt.operation = isNullOrUndefined(operation) ? null : operation;
    });

    this.setState({
      parts: parts,
      operationList: operationList,
      gtPartMappings: gtPartMappings,
      isLoading: false,
      organizationId: hoId
    });
  };

  public hasRight = (right: string): boolean => {
    return this.props.appState!.user!.profile.role.includes(right);
  };

  private handleGTPartChange = (newValue: IReferential | null) => {
    this.setState({
      newGTPartMapping: {
        ...this.state.newGTPartMapping,
        gtPart: newValue,
        gtPartId: newValue !== null ? newValue!.id : 0
      }
    });
  };
  
  private handleOperationChange = (newValue: IReferential | null) => {
    this.setState({
      newGTPartMapping: {
        ...this.state.newGTPartMapping,
        operation: newValue,
        operationId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  public saveGTPartMapping = async () => {
    if (this.state.newGTPartMappingId === null) {
      if (
        this.state.gtPartMappings.findIndex(
          (item) => item.gtPartId === this.state.newGTPartMapping!.gtPartId && item.operationId === this.state.newGTPartMapping!.operationId
        ) !== -1
      ) {
        this.props.enqueueSnackbar(
          this.translatorService.Tranlate(
            'ORGANIZATION_PART_WITH_OPERATION_EXISTS',
            'Piesa + operatia exista deja!'
          ),
          { variant: 'error' }
        );
        return;
      }
      try {
        await this.caseService.AddGTPartMapping({
          ...this.state.newGTPartMapping,
          organizationId: this.state.organizationId
        });

        await this.loadData();

        this.closeDialog();

        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    } else {
        if (
          this.state.gtPartMappings.findIndex(
            (item) => item.gtPartId === this.state.newGTPartMapping!.gtPartId && item.operationId === this.state.newGTPartMapping!.operationId && item.id !== this.state.newGTPartMappingId
          ) !== -1
        ) {
          this.props.enqueueSnackbar(
            this.translatorService.Tranlate(
              'ORGANIZATION_PART_WITH_OPERATION_EXISTS',
              'Piesa + operatia exista deja!'
            ),
            { variant: 'error' }
          );
          return;
        }
      try {
        await this.caseService.UpdateGTPartMapping({
          ...this.state.newGTPartMapping,
          organizationId: this.state.organizationId
        });

        await this.loadData();

        this.closeDialog();

        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };
  
  
  NumberFormatCustom = (props: any) => {
    const { inputRef, onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values: any) => {
          onChange({
            target: {
              value: values.value
            },
            currentTarget: {
              value: values.value
            }
          });
        }}
        allowNegative={false}
        thousandSeparator={false}
        decimalScale={2}
      />
    );
  };

  onChange =
  (fieldName: string, isNumber: boolean) => (e: any, newValue?: IReferential | null) => {
    isNumber
      ? this.setState({
        newGTPartMapping: {
            ...this.state.newGTPartMapping,
            [fieldName]: parseFloat(newValue || e.target.value)
          }
        })
      : this.setState({
        newGTPartMapping: {
            ...this.state.newGTPartMapping,
            [fieldName]: newValue || e.target.value
          }
        });
  };

  public renderAddForm() {
    return (
      <ValidatorForm onSubmit={this.saveGTPartMapping} instantValidate={true}>
                <Box mb={2}>
          <Autocomplete
            id="part"
            fullWidth
            options={this.state.parts}
            value={this.state.newGTPartMapping.gtPart}
            onChange={(e: any, newValue: IReferential | null) =>
              this.handleGTPartChange(newValue)
            }
            getOptionLabel={(option: IReferential) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="part"
                value={this.state.newGTPartMapping.gtPart}
                label={this.translatorService.Tranlate(
                  'ORGANIZATION_PART_PART_LABEL',
                  'Piesa'
                )}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate(
                    'VALIDATORS_REQUIRED',
                    'Campul este obligatoriu'
                  )
                ]}
              />
            )}
          />
        </Box>
        <Box mb={2}>
          <TextValidator
            fullWidth
            id="cupiCodes"
            name="cupiCodes"
            placeholder={this.translatorService.Tranlate('ORGANIZATION_PART_CUPI_CODES', 'Coduri CUPI')}
            value={this.state.newGTPartMapping.cupiCodes}
            onChange={(e: any) =>
              this.onChange('cupiCodes', false)(e)
            }
            validators={['required']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
            ]}
            label={this.translatorService.Tranlate('ORGANIZATION_PART_CUPI_CODES', 'Coduri CUPI')}
          />
        </Box>
        <Box mb={2}>
          <Autocomplete
            id="operationList"
            fullWidth
            options={this.state.operationList}
            value={this.state.newGTPartMapping.operation}
            onChange={(e: any, newValue: IReferential | null) =>
              this.handleOperationChange(newValue)
            }
            getOptionLabel={(option: IReferential) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="operation"
                value={this.state.newGTPartMapping.operation}
                label={this.translatorService.Tranlate(
                  'ORGANIZATION_PART_OPERATION_LABEL',
                  'Operatiune'
                )}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate(
                    'VALIDATORS_REQUIRED',
                    'Campul este obligatoriu'
                  )
                ]}
              />
            )}
          />
        </Box> 

        <FormControlLabel
          className="m-2 pr-3 mt-0"
          control={
            <Switch
              id="requiresDamageLevel"
              checked={
                this.state.newGTPartMapping!.requiresDamageLevel
                  ? this.state.newGTPartMapping!.requiresDamageLevel
                  : false
              }
              onChange={(e) =>
                this.setState({
                  newGTPartMapping: {
                    ...this.state.newGTPartMapping!,
                    requiresDamageLevel: e.target.checked
                  }
                })
              }
              color="primary"
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
          }
          label={
            <Typography
              variant="body2"
              color="textPrimary"
              className="font-weight-bold"
              align="left"
            >
              {this.translatorService.Tranlate('ORGANIZATION_PART_HAS_PAINT_TYPE', 'Are Tip Vopsitorie')}
            </Typography>
          }
          labelPlacement="start"
        />

        <div className="text-right">
          <Button
            className="m-2"
            variant="outlined"
            color="default"
            onClick={this.closeDialog}
          >
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_CANCEL_BTN', 'Anuleaza')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
          </Button>
        </div>
      </ValidatorForm>
    );
  }

  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: {
          display: 'excluded',
          filter: false
        } as MUIDataTableColumnOptions
      },
      {
        name: 'gtPart',
        label: this.translatorService.Tranlate('ORGANIZATION_PART_PART_LABEL', 'Piesa'),
        options: {
          sort: true,
          customSort: (a: IReferential, b: IReferential) => {
            return a.displayName!.localeCompare(b.displayName!);
          },
          customBodyRender: (value: IReferential) => {
            return value ? value.displayName : "";
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'cupiCodes',
        label: this.translatorService.Tranlate('ORGANIZATION_PART_CUPI_CODES', 'Coduri CUPI'),
        options: {
          filter: false,
          customBodyRender: (value: string, tableMeta: MUIDataTableMeta) => {
            return value;
          }
        }
      },
      {
        name: 'operation',
        label: this.translatorService.Tranlate(
          'ORGANIZATION_PART_OPERATION_LABEL',
          'Operatiune'
        ),
        options: {
          sort: true,
          customSort: (a: IReferential, b: IReferential) => {
            return a.displayName!.localeCompare(b.displayName!);
          },
          customBodyRender: (value: IReferential) => {
            return value ? value.displayName : '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'requiresDamageLevel',
        label: this.translatorService.Tranlate('ORGANIZATION_PART_HAS_PAINT_TYPE', 'Are Tip Vopsitorie'),
        options: {
          filterOptions: {
            names: [
              this.translatorService.Tranlate('TABLE_IS_ACTIVE_COLUMN_ACTIVE', 'Activ'),
              this.translatorService.Tranlate('TABLE_IS_ACTIVE_COLUMN_INACTIVE', 'Inactiv')
            ],
            logic(isActive: any, filterVal: string[]) {
              const show =
                (filterVal.indexOf(this.names![0]) !== -1 && isActive === true) ||
                (filterVal.indexOf(this.names![1]) !== -1 && isActive === false);
              return !show;
            }
          },
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <Switch
                checked={value ? value : false}
                onChange={(e) => this.handleRequiredDamageLevelChange(e, tableMeta)}
                color="primary"
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            );
          }
        }  as MUIDataTableColumnOptions
      },
      {
        name: '',
        options: {
          viewColumns: false,
          filter: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={(e) => this.newGTPartMappingPopup(tableMeta.rowData[0])}
                >
                  <EditOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => this.deleteGTPartMapping(e, tableMeta)}
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </>
            );
          }
        }
      }];

    return columns;
  };

  deleteGTPartMapping = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];

      await this.caseService.RemoveGTPartMapping(id);

      await this.loadData();

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  handleRequiredDamageLevelChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    tableMeta: MUIDataTableMeta
  ) => {
    const id = tableMeta.rowData[0];
    const gtPartMappings = [...this.state.gtPartMappings];
    const updateGTPartMappingIndex = gtPartMappings.findIndex((o) => o.id === id);

    if (updateGTPartMappingIndex >= 0) {
      gtPartMappings[updateGTPartMappingIndex] = {
        ...gtPartMappings[updateGTPartMappingIndex],
        requiresDamageLevel: event.target.checked
      };

      try {
        await this.caseService.UpdateGTPartMapping(
          gtPartMappings[updateGTPartMappingIndex]
        );

        this.setState({ gtPartMappings: gtPartMappings });

        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };

  newGTPartMappingPopup = async (gtPartMappingId: number | null) => {
    let gtPartMapping: GTPartMapping;
    if (gtPartMappingId == null) {
      gtPartMapping = { ...this.state.newGTPartMapping } as GTPartMapping;
    } else {
      gtPartMapping = this.state.gtPartMappings.find((item) => item.id === gtPartMappingId)!;
    }
    
    this.setState({
      isDialogOpen: true,
      newGTPartMapping: gtPartMapping,
      newGTPartMappingId: gtPartMappingId
    });
  };

  closeDialog = async () => {
    this.setState(
      { 
        isDialogOpen: false,
        newGTPartMapping: this.newGTPartMapping,
        newGTPartMappingId: null
      }
    );
  };

  openImportDialog = async () => {
    this.setState({
      isImportDialogOpen: true,
      isLoadingImportData: false,
      attachments: [],
      importedGTPartMappingList: []
    });
  };

  closeImportDialog = async () => {
    this.setState(
      { 
        isImportDialogOpen: false,
        isLoading: true,
        importedGTPartMappingList: [],
        attachments: []
      },
      async () => {
        await this.loadData();
      }
    );
  };

  handleDeleteAttachment = async (id: number, fileName: string) => {
    try {
      const attachments = [...this.state.attachments];
      const index = attachments.findIndex((item) => item.id === id);
      attachments.splice(index, 1);

      this.setState({
        attachments: attachments
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  canUpload = (): boolean => {
    const files = this.state.attachments;

    if (files.length >= 1) {
      return false;
    }

    return true;
  };

  handleUploadAttachment = async (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const attachments = [...this.state.attachments];
      attachments.push({
        id: 0,
        file: e.target.files![0],
        fileName: e.target.files![0].name,
        uploadDate: new Date(),
        originalFileName: e.target.files![0].name
      });
      e.target.value = '';

      this.setState({
        attachments: attachments
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  renderAttachmentBox = () => {
    return (
      <Grid container spacing={2} className="mt-2 mb-5">
        <Grid item xs={9}>
          {this.state.attachments.length !== 0
            ? this.state.attachments.map((attach, index) => {
                return (
                  <div key={index} className="d-flex flex-row w-100">
                    <div className="w-75 text-left">
                      <Button
                        color="primary"
                        className="text-primary text-left pl-0"
                        disabled={false}
                        onClick={(e) => {
                          console.log('download');
                        }}
                      >
                        <span className="crop">{attach.originalFileName}</span>
                      </Button>
                    </div>
                    <div className="w-25">
                      <IconButton
                        aria-label="delete"
                        color="inherit"
                        className="text-danger"
                        size="small"
                        onClick={(e) => {
                          this.handleDeleteAttachment(attach.id, attach.fileName);
                        }}
                        disabled={false}
                      >
                        <DeleteOutlineTwoToneIcon />
                      </IconButton>
                    </div>
                  </div>
                );
              })
            : null}
        </Grid>
        <Grid item xs={3} container justify="flex-end" direction="column">
          <Button
            variant="outlined"
            size="small"
            color="primary"
            className="d-block text-center shadow-none"
            component="div"
            disabled={!this.canUpload()}
          >
            <input
              accept=".xls, .xlsx"
              className="d-none"
              id={'contained-button-file'}
              onChange={(e) => {
                return this.handleUploadAttachment(e);
              }}
              type="file"
              disabled={!this.canUpload()}
            />
            <label
              htmlFor={'contained-button-file'}
              className="w-100 mb-0"
            >
                {this.translatorService.Tranlate(
                'MAVO_VEHICLES_UPLOAD_FILE_BTN_LABEL',
                'Uploadeaza fisier'
              )}
            </label>
          </Button>
        </Grid>
      </Grid>
    );
  };

  handleImport = async () => {
    if (this.state.attachments.length === 0) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG_FILE_NOT_SELECTED', 'Va rugam sa selectati un fisier!'), {
        variant: 'error'
      });
      return;
    }
    this.setState({
      isLoadingImportData: true
    });

    const request = {
      attachments: this.state.attachments,
      organizationId: this.state.organizationId
    } as GTPartMappingImportRequestDto;

    try {
      const result = await this.caseService.SaveImportedGTPartMapping(request);
      this.props.enqueueSnackbar(
        <div>
          <p>
            {this.translatorService.Tranlate('ORGANIZATION_PART_DATA_PROCESSED', 'Date tratate: ')}{' '}
            {result.totalNumber}
          </p>
          <p>
            {this.translatorService.Tranlate('ORGANIZATION_PART_TREATED_SUCCESSFULLY', 'Tratate cu succes: ')}{' '}
            {result.importedNumber}
          </p>
        </div>,
        {
          variant: 'info',
          autoHideDuration: 6000
        }
      );
      this.setState({
        importedGTPartMappingList: result.gtPartMappingList,
        isLoadingImportData: false
      });

    } catch {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error',
        autoHideDuration: 6000
      });
      this.setState({
        isLoadingImportData: false
      });
    }
  };

  getImportedColumns = () => {
    return [
      {
        field: 'gtPartName',
        title: this.translatorService.Tranlate(
          'ORGANIZATION_PART_PART_LABEL',
          'Piesa'
        )
      },
      {
        field: 'cupiCodes',
        title: this.translatorService.Tranlate(
          'ORGANIZATION_PART_CUPI_CODES',
          'Coduri CUPI'
        ),
      },
      {
        field: 'operationName',
        title: this.translatorService.Tranlate(
          'ORGANIZATION_PART_OPERATION_LABEL',
          'Operatiune'
        )
      },
      {
        field: 'requiresDamageLevel',
        title: this.translatorService.Tranlate(
          'ORGANIZATION_PART_HAS_PAINT_TYPE',
          'Are Tip Vopsitorie'
        ),
        render: (rowData: GTPartMappingImportedDto) => {
          return rowData.requiresDamageLevel ? 1 : 0;
        },
      },
      {
        field: 'importMessage',
        title: this.translatorService.Tranlate(
          'MAVO_VEHICLES_VEHICLE_IMPORT_MESSAGE',
          'Rezultat import'
        )
      }
    ];
  }
  
  renderImportedResultBox = () => {
    return this.state.importedGTPartMappingList.length > 0 ? (
      <MaterialTable
        columns={this.getImportedColumns()}
        data={this.state.importedGTPartMappingList}
        title=""
        icons={MaterialTableIcons}
        localization={getLocalization(this.translatorService)}
        options={{
          actionsColumnIndex: -1,
          addRowPosition: 'first',
          maxBodyHeight: 400,
          paging: false,
          sorting: false,
          search: false
        }}
        components={{
          Container: (props) => <Paper {...props} elevation={0} />
        }}
      />
    ) : '';
  }
  
  public renderImportContent() {
    return (
      <ValidatorForm onSubmit={this.handleImport} instantValidate={true}>
        {this.renderAttachmentBox()}
        <div className="d-flex flex-row text-center flex-wrap justify-content-center">
          <ScaleLoader color={'var(--primary)'} loading={this.state.isLoadingImportData} />
        </div>
        {this.renderImportedResultBox()}
        <div className="text-right">
          <Button
            className="m-2"
            variant="outlined"
            color="default"
            onClick={this.closeImportDialog}
          >
            {this.translatorService.Tranlate('MAVO_VEHICLE_IMPORT_CLOSE_BTN', 'Renunta')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit" 
            disabled={this.state.isLoadingImportData}>
            {this.translatorService.Tranlate('MAVO_VEHICLE_IMPORT_BTN', 'Importa')}
          </Button>
        </div>
      </ValidatorForm>
    );
  }

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.appReferentialService = (this.context as AppContext).referentialService;
    this.caseService = (this.context as AppContext).caseService;

    const options = {
      filter: true,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      sort: false,
      customToolbar: () => {
        return (
          <div>
            <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
              <IconButton
                aria-label="add"
                color="secondary"
                className="m-2"
                onClick={(e) => this.newGTPartMappingPopup(null)}
              >
                <AddCircleTwoToneIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={this.translatorService.Tranlate('Import', 'Importa')}>
              <IconButton
                aria-label="import"
                color="primary"
                className="m-2"
                onClick={(e) => this.openImportDialog()}
              >
                <CloudUploadOutlined />
              </IconButton>
            </Tooltip>
          </div>
        );
      }
    };

    return (
      <Fragment>
        <Box>
          <Card>
            <CardContent>
              <Tabs
                value={0}
                indicatorColor="primary"
                textColor="primary"
                variant="standard"
                color="primary"
                aria-label="disabled tabs example"
              >
                <Tab
                  className="text-capitalize"
                  label={this.translatorService.Tranlate('ORGANIZATION_PART_TAB_NAME', 'Piese GT')}
                />
              </Tabs>
            </CardContent>
          </Card>
        </Box>
        <Box mt={1} pt={1}>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? (
            <MUIDataTable
              title={''}
              data={this.state.gtPartMappings}
              columns={this.getColumns()}
              options={options}
            />
          ) : null}
        </Box>
        {this.state.isDialogOpen ? (
          <Dialog
            onClose={this.closeDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isDialogOpen}
            fullScreen={false}
            fullWidth={true}
          >
            <DialogTitle id="customized-dialog-title">
              <Grid container>
                <Grid item xs={11}>
                  <Typography className="MuiTypography-h4">
                  {!this.state.newGTPartMappingId ? 
                    this.translatorService.Tranlate(
                      'ORGANIZATION_PART_NEW_MODAL_TITLE',
                      'Adauga piesa organizatie'
                    ) : this.translatorService.Tranlate(
                      'ORGANIZATION_PART_EDIT_MODAL_TITLE',
                      'Actualizeaza piesa organizatie'
                    )}       
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>
              {this.renderAddForm()}
            </DialogContent>
          </Dialog>
        ) : (
          ''
        )}

         {this.state.isImportDialogOpen ? (
            <Dialog
              onClose={this.closeImportDialog}
              aria-labelledby="customized-dialog-title"
              open={this.state.isImportDialogOpen}
              fullScreen={true}
              fullWidth={true}
              >
              <DialogTitle
                id="customized-dialog-title"
                style={{
                  color: '#ffffff',
                  backgroundColor: 'var(--primary)',
                  textAlign: 'center'
                }}
              >
                <span style={{ fontSize: '20px', lineHeight: '24px' }}>
                  {this.translatorService.Tranlate(
                  'ORGANIZATION_PART_IMPORT_MODAL_TITLE',
                  'Importa piese'
                  )}                    
                </span>
                <IconButton
                  aria-label="close"
                  className="position-absolute"
                  style={{ right: 12, top: 12, color: '#ffffff' }}
                  onClick={this.closeImportDialog}
                  size={'small'}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers>
                <Box m={1} p={1}>
                  {this.renderImportContent()}
                </Box>
              </DialogContent>
            </Dialog>
            ) : (
              ''
            )}
      </Fragment>
    );
  }
}

export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(GTPartMappings as any));
